import { BaseService } from 'core/services';
import SubCategoryRouteService from './SubCategoryRouteService';

class SubCategoryService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new SubCategoryRouteService());
    }
}

export default SubCategoryService;
